export default {"src":"/_next/static/media/home-good-conduct-purple.fe7da4de.svg","height":98,"width":71,"blurWidth":0,"blurHeight":0};